import { Tab } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';

export default function PositionedMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<any>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tab label="Explore" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" onClick={handleClick} />

      <Menu
        sx={{ textTransform: 'uppercase' }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleClose} component="a" href="/v2/i/marketplace">
          Cloud based simulators
        </MenuItem>
        <MenuItem onClick={handleClose} component="a" href="/v2/i/shipmodel">
          Ship models
        </MenuItem>
      </Menu>
    </>
  );
}
